function displayUserName(user: { name: string, email: string }, isElseEmail?: boolean): string {
  return (user.name || '') || (isElseEmail ? user.email : '');
}

export default displayUserName;
